export const getWorkflow = (state) => state.dokbot.workflow;
